import AxiosCustom from "../../common/components/apiConfig";

export function pishroOtpLogin(
	otp,
	national_id,
	is_individual,
	captchaValue,
	captcha_id,
) {
	let config = {
		url: "login",
	};
	let data = {
		method_type: "login",
		data: {
			login_flag: "otp",
			national_id: national_id,
			is_individual: is_individual,
			otp: otp,
			captcha_value: captchaValue,
			captcha_id: captcha_id,
		},
	};

	return AxiosCustom(config, data);
}
